module.exports = __webpack_public_path__ + "media/images/lb/554-60f3d283425233d569b0b8cc88b7bdf0.svg";